import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

/** A web origin allowed to frame this account's embedded widgets (Embedded Components). */
export interface EmbedOrigin {
  id: string;
  origin: string;
  status: string;
  createdOn?: string;
  createdBy?: string;
}

/** GET /secure/embed/origins -- account admins only. */
export const fetchEmbedOrigins = async (): Promise<EmbedOrigin[]> => {
  const callParams = await getCallParams("GET");
  const response = await makeCall(urls.EMBED_ORIGINS, callParams);
  return Array.isArray(response) ? response : [];
};

/** POST /secure/embed/origins -- the server normalises the origin and stores it. */
export const addEmbedOrigin = async (origin: string): Promise<EmbedOrigin> => {
  const callParams = await getCallParams("POST", { origin });
  return makeCall(urls.EMBED_ORIGINS, callParams);
};

/** DELETE /secure/embed/origins/{id}. */
export const removeEmbedOrigin = async (id: string) => {
  const callParams = await getCallParams("DELETE");
  return makeCall(`${urls.EMBED_ORIGINS}/${encodeURIComponent(id)}`, callParams);
};
